import '../c/layoutid_RWKAMP.pcss';
import 'jquery';
import './layoutid_RWKAMP/lib/swiper/js/swiper.js';

import app from './layoutid_RWKAMP/kamp-app';

app();
